export default "__VITE_ASSET__izufeQsw__"